<template>
  <!--
    Marca del footer: logo "gov.co" (blanco) a la izquierda, un separador
    vertical y el sello "CO Colombia" a la derecha, como en la barra GOV.CO.
  -->
  <div class="logo-co-gov">
    <img
      class="logo-co-gov__gov"
      :src="govLogo"
      alt="gov.co"
    />
    <span class="logo-co-gov__divider" aria-hidden="true"></span>
    <img
      class="logo-co-gov__co"
      :src="coLogo"
      alt="Marca país CO - Colombia"
    />
  </div>
</template>

<script>
import govLogo from "@/assets/img/logo-footer-gov.png";
import coLogo from "@/assets/img/logo-footer-co-gov.svg";

export default {
  data() {
    return {
      govLogo,
      coLogo,
    };
  },
};
</script>

<style scoped>
.logo-co-gov {
  display: inline-flex;
  align-items: center;
  gap: 16px;
}

.logo-co-gov__gov {
  height: 24px;
  width: auto;
}

.logo-co-gov__divider {
  width: 1px;
  height: 32px;
  background-color: rgba(255, 255, 255);
}

.logo-co-gov__co {
  height: 40px;
  width: auto;
}
</style>
